import { render, staticRenderFns } from "./mini-cart.vue?vue&type=template&id=5a38afc6&"
import script from "./mini-cart.vue?vue&type=script&lang=js&"
export * from "./mini-cart.vue?vue&type=script&lang=js&"
import style0 from "./mini-cart.vue?vue&type=style&index=0&id=5a38afc6&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports